import React from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { browserHistory } from 'react-router';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import Osms from '../images/vopr.png';
import logo from '../images/logo.jpg';
import { isAuthenticated, redirectToLogin } from '../utils/authHelper';

/**
 * Login Page — Same UI as before, just uses Bifrost for authentication.
 * 
 * Original flow:  "Login with Google" → /google (Passport OAuth)
 * Bifrost flow:   "Login with Google" → Bifrost Login Service (Cognito OAuth)
 */
class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = { invalidLogin: false };
  }

  redirectToGoogle() {
    // Redirect to Bifrost Login Service (replaces old Passport Google OAuth)
    redirectToLogin();
  }

  componentWillMount() {
    /* Ensure login page has no sidebar body class */
    document.body.classList.remove('sidebar-open', 'sidebar-closed');
    document.body.classList.add('no-sidebar');

    if (isAuthenticated()) {
      browserHistory.push('/home');
    }
  }

  render() {
    return (
      <MuiThemeProvider muiTheme={getMuiTheme()}>
        <div className="zaps-login-outer">

          {/* ── Left: Branding Panel ── */}
          <div className="zaps-login-branding">
            <div className="zaps-login-branding-inner">
              <img src={logo} alt="Zolo Logo" />
              <h1>ZAPS</h1>
              <p>
                Zolo Accounting &amp; Payment System —<br />
                your central hub for vendor management,<br />
                payments, and financial reporting.
              </p>

              {/* decorative ZAPS watermark logo */}
              <div style={{ marginTop: 48, opacity: 0.18 }}>
                <img src={Osms} alt="" style={{ height: 80, filter: 'invert(1)' }} />
              </div>
            </div>
          </div>

          {/* ── Right: Sign-in Card ── */}
          <div className="zaps-login-card-panel">
            <div style={{ marginBottom: 32, textAlign: 'center' }}>
              <img src={logo} alt="Zolo" style={{ height: 48, width: 48, borderRadius: 12, marginBottom: 16 }} />
            </div>

            <h2>Welcome back</h2>
            <p>Sign in to your ZAPS account to continue.</p>

            <button
              className="zaps-google-btn"
              onClick={this.redirectToGoogle.bind(this)}
            >
              <span className="google-g" />
              Continue with Google
            </button>

            <p className="zaps-login-fine-print">
              By signing in you agree to Zolo's internal usage policies.<br />
              Access is restricted to authorised Zolo employees only.
            </p>
          </div>

        </div>
      </MuiThemeProvider>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login.js